const getSliderItemCssWidth = (marginBetweenItems: string, items: number) => {
  return `calc((100% - ${marginBetweenItems} * ${items - 1}) / ${items})`;
};

export default getSliderItemCssWidth;
